import React from "react"
import get from "lodash/get"
import Img from "gatsby-image"
import Link from "../link"

const Poi = ({ image, title, type, body, url, hideReadMore }) => {
  const poiUrl = `/poi/${url}`

  return (
    <div className="w-full h-full bg-white">
      <div className="flex flex-col h-full rounded-lg shadow-lg">
        {image && <Img className="mb-0 rounded-t-lg" fluid={image.fluid} />}

        <div className="flex flex-col items-start flex-1 p-6 space-y-4">
          {title && !url && <h2 className="text-2xl font-bold">{title}</h2>}
          {title && url && (
            <h2 className="mb-0 text-2xl font-bold">
              <Link to={poiUrl}>{title}</Link>
            </h2>
          )}
          {type && (
            <span className="inline-block px-4 text-xs text-center lowercase bg-gray-200 border rounded-full">
              {type}
            </span>
          )}
          {body && (
            <div
              className="flex-1"
              dangerouslySetInnerHTML={{
                __html: get(body, "childMarkdownRemark.excerpt"),
              }}
            ></div>
          )}
          {url && !hideReadMore && (
            <Link to={poiUrl} className="text-sm font-bold">
              Lees meer
            </Link>
          )}
        </div>
      </div>
    </div>
  )
}

Poi.propTypes = {}

Poi.defaultProps = {
  hideReadMore: false,
}

export default Poi
